module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/upload-folder-77d749afb2782806e4d694f8feef0161.svg";